import { Box, IconNew, IconNewOptions, ModBox, SpacerNew, TextNew } from '@jfs/ui-new'
import { memo, useCallback } from 'react'
import { styles } from './styles'

interface DownloadFileComponentInterface {
  type: 'download' | 'Edit' | 'View' | 'delete' | 'replace'
  title: string
  onButtonPress?: (data?: any) => void
  alignment?: 'flex-start' | 'center' | 'flex-end'
  data?: any
  color?: any
  showBorder?: boolean
}

export const DownloadFileComp = memo(
  ({
    type,
    title,
    onButtonPress,
    alignment,
    data,
    color = 'BLUE',
    showBorder = false,
  }: DownloadFileComponentInterface) => {
    const returnIcon = () => {
      if (type === 'Edit') {
        return 'EDIT' as IconNewOptions
      } else if (type === 'View') {
        return 'EYE_WATCH' as IconNewOptions
      } else if (type === 'download') {
        return 'DOWNLOAD' as IconNewOptions
      } else if (type === 'delete') {
        return 'DELETE' as IconNewOptions
      } else if (type === 'replace') {
        return 'ICON_REFRESH' as IconNewOptions
      }
    }

    const showIcon =
      type === 'download' || type === 'View' || type === 'Edit' || type === 'delete' || type === 'replace'
    const onPress = useCallback(() => {
      if (onButtonPress && data) {
        onButtonPress(data)
      } else if (onButtonPress) {
        onButtonPress()
      }
    }, [data, onButtonPress])

    return (
      <Box
        {...styles.downloadBox}
        alignSelf={alignment}
        onPress={onPress}
        underlayColor="LIGHTEST_GREY"
        borderWidth={showBorder ? 1 : 0}
        borderColor={showBorder ? 'BORDER_COLOR' : undefined}
        borderRadius={showBorder ? 4 : undefined}
        paddingHorizontal={showBorder ? 6 : undefined}>
        <ModBox show={showIcon}>
          <IconNew id={returnIcon() as IconNewOptions} color={color} />
        </ModBox>
        <SpacerNew direction="horizontal" size={5} />
        <TextNew
          title={title ?? 'Download File'}
          {...(color !== 'BLUE' ? styles.downloadTextWhite : styles.downloadText)}
          selectable={false}
        />
      </Box>
    )
  },
)
